export * from './fond-gespeichert.interface';
